<template>
    <v-card class="pa-6 pa-sm-10">
        <LigipaasetavusTekst/>
    </v-card>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import LigipaasetavusTekst from "@/components/ligipaasetavus/LigipaasetavusTekst.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
    name: 'Ligipaasetavus' ,
    components: { LigipaasetavusTekst },
})
</script>

<style scoped>

</style>